module.exports = __webpack_public_path__ + "img/peixun.257e4eb7.jpg";